<template>
  <div>
    <Title title="Planificar STS"
           subtitle="Crea tus rutas Site to Store"/>
    <el-row :gutter="20" v-if="planningTracker === null">
      <el-col :lg="7" :md="24">
        <GeneralData ref="generalData"
                     @data="getGeneralData"/>
      </el-col>
      <el-col :lg="17" :md="24">
        <SuborderList @suborders="getSuborders"/>
        <Send ref="sendData"
              @validation="validation"
              @success="successPlanning"/>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col>
        <PlanningSuccess :planningTracker="planningTracker"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import Send from '../components/planningSts/Send.vue';
import PlanningSuccess from '../components/planningSts/Success.vue';
import GeneralData from '../components/planningSts/GeneralData.vue';
import SuborderList from '../components/planningSts/suborder/List.vue';

export default {
  name: 'PlanningStsV2',
  components: {
    Send,
    Title,
    GeneralData,
    SuborderList,
    PlanningSuccess,
  },
  data() {
    return {
      planningTracker: null,
    };
  },
  methods: {
    validation() {
      this.$refs.generalData.validation();
    },
    getGeneralData(data, validGeneralData) {
      this.$refs.sendData.showSummary(data, validGeneralData);
    },
    getSuborders(data) {
      this.$refs.sendData.getSuborders(data);
    },
    successPlanning(id) {
      this.planningTracker = id;
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-col { margin-bottom: 40px; }
</style>
